import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

interface SeoProps {
  title: string
  description: string
  image?: string
  noindex?: boolean
}

const SITE_NAME = 'Fit by Cassie'
const SITE_URL = 'https://fitbycassie.com'
const DEFAULT_IMAGE = '/images/cassie-hero-navy.webp'

const Seo: React.FC<SeoProps> = ({ title, description, image = DEFAULT_IMAGE, noindex = false }) => {
  const { pathname } = useLocation()
  const fullTitle = `${title} | ${SITE_NAME}`
  const url = `${SITE_URL}${pathname}`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE_URL}${image}`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${SITE_URL}${image}`} />
    </Helmet>
  )
}

export default Seo
